import { render, staticRenderFns } from "./refresh-tracking-db.vue?vue&type=template&id=dc3453de&scoped=true"
import script from "./refresh-tracking-db.vue?vue&type=script&lang=js"
export * from "./refresh-tracking-db.vue?vue&type=script&lang=js"
import style0 from "./refresh-tracking-db.vue?vue&type=style&index=0&id=dc3453de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc3453de",
  null
  
)

export default component.exports